import React from 'react';
import {NavLink} from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import CustomerSelector from "./components/CustomerSelector";
import LogoImage from "./components/LogoImage";
import "./NavMenu.scss"
import {useAppSelector} from "./store";
import {isAuthenticatedSelector, selectedCustomerSelector} from "./store/slice/auth";

const NavMenu = () => {

    const isAuthenticated = useAppSelector(isAuthenticatedSelector);
    const selectedCustomer = useAppSelector(selectedCustomerSelector);

    let logoLink = "#/deliveries";
    let logoLinkOpenInNewWindow = false;
    if (selectedCustomer?.tenant && selectedCustomer.tenant.website) {
        logoLink = `https://${selectedCustomer.tenant.website}`;
        logoLinkOpenInNewWindow = true;
    }

    return (
        <Navbar id="navmain" collapseOnSelect bg="light" expand="lg">
            <Container className="px-2 px-sm-0">
                <Navbar.Brand href={logoLink} target={logoLinkOpenInNewWindow ? "_blank" : ""} rel="noopener noreferrer">
                    <LogoImage />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {/* I found that "collapseOnSelect" works if we add "eventKey" to Nav.Link item */}
                        {isAuthenticated && <Nav.Link eventKey="1" as={NavLink} to="/deliveries">Deliveries</Nav.Link>}
                        {isAuthenticated && <Nav.Link eventKey="2" as={NavLink} to="/hires">Hires</Nav.Link>}
                        {isAuthenticated && <Nav.Link eventKey="3" as={NavLink} to="/logout">Sign out</Nav.Link>}
                        {!isAuthenticated && <Nav.Link eventKey="4" as={NavLink} to="/login">Sign in</Nav.Link>}
                        {!isAuthenticated && <Nav.Link eventKey="5" as={NavLink} to="/forgot-password">Forgot password</Nav.Link>}
                    </Nav>
                    <CustomerSelector />
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );

}

export default NavMenu;
